<template>
  <b-modal
    id="modal-scrollable"
    v-model="$store.state.someVariables.showNewInstitucion"
    scrollable
    no-close-on-backdrop
    title="Agregar Institución"
    cancel-variant="outline-secondary"
    @hidden="resetModal"
  >
    <b-row>
      <b-col md="12" class="d-flex justify-content-center">
        <croppa
          v-model="croppaFoto"
          :width="220"
          :height="220"
          placeholder="Subir foto equipo"
          placeholder-color="#543338"
          :placeholder-font-size="16"
          canvas-color="transparent"
          :show-remove-button="true"
          remove-button-color="black"
          :show-loading="false"
          :loading-size="50"
          loading-color="#606060"
          :initial-image="institucion.foto"
        ></croppa>
      </b-col>
      <b-col md="12" style="margin-top:15px">
        <div class="form-label-group">
          <b-form-input
            id="floating-institucion"
            placeholder="Ingrese Institución *"
            v-model="institucion.nombre"
            style="text-transform: uppercase"
          />
          <label for="floating-institucion">Institución *</label>
        </div>
      </b-col>
      <b-col md="12" style="margin-top:5px">
        <div class="form-label-group">
          <b-form-input
            id="floating-apodo"
            placeholder="Ingrese Apodo *"
            v-model="institucion.apodo"
            style="text-transform: uppercase"
          />
          <label for="floating-apodo">Apodo *</label>
        </div>
      </b-col>
      <b-col md="6" style="margin-top:5px">
        <div class="form-label-group">
          <b-form-input
            id="floating-email"
            placeholder="Ingrese Email"
            v-model="institucion.email"
          />
          <label for="floating-email">Email</label>
        </div>
      </b-col>
      <b-col md="6" style="margin-top:5px">
        <div class="form-label-group">
          <b-form-input
            id="floating-telefono"
            placeholder="Ingrese Telefono"
            type="number"
            v-model="institucion.telefono"
          />
          <label for="floating-telefono">Telefono</label>
        </div>
      </b-col>
      <b-col md="6" style="margin-top:5px">
        <div class="form-label-group">
          <b-form-input
            id="floating-presidente"
            placeholder="Ingrese Presidente"
            v-model="institucion.presidente"
            style="text-transform: capitalize"
          />
          <label for="floating-presidente">Presidente</label>
        </div>
      </b-col>
      <b-col md="6" style="margin-top:5px">
        <div class="form-label-group">
          <b-form-input
            id="floating-vice"
            placeholder="Ingrese Vicepresidente"
            v-model="institucion.vicepresidente"
            style="text-transform: capitalize"
          />
          <label for="floating-vice">Vicepresidente</label>
        </div>
      </b-col>
      <b-col md="12" style="margin-top:5px">
        <div class="form-label-group">
          <b-form-input
            id="floating-facebook"
            placeholder="Ingrese link facebook"
            v-model="institucion.facebook"
          />
          <label for="floating-facebook">Facebook</label>
        </div>
      </b-col>
    </b-row>
    <span
      v-if="institucion.usuario != null"
      style="background:#c8ffa0; padding:5px; border-radius:3px;    font-size: 12px;
    font-weight: bold"
      >Creado por : {{ institucion.usuario }}
      {{ institucion.fecha_creacion }}</span
    >
    <br /><br />
    <template v-if="listAuditoria.length != 0">
      <span
        style="text-decoration: underline; padding:3px ;cursor:pointer;color:brown;font-size:13px"
        id="audit-1"
        >Ver control de cambios</span
      >
      <b-popover
        ref="popover"
        target="audit-1"
        triggers="hover"
        :show.sync="popoverShow"
        placement="auto"
        style="width:500px !important"
      >
        <template v-slot:title>
          <div>
            <span>Detalle Cambios</span>
          </div>
        </template>
        <div style="max-height: 350px; overflow-y: auto;">
          <div
            style="background:#ececec;margin-top:10px; padding:4px;"
            v-for="item in listAuditoria"
            :key="item.id"
          >
            <span style="font-size:11px;font-weight: bold;"
              >{{ item.fecha }} </span
            ><br /><span style="font-size:12px">{{ item.accion }}</span>
            <br />
            <span style="font-size:12px;font-weight: bold">{{
              item.usuario
            }}</span>
          </div>
        </div>
      </b-popover>
    </template>
    <template #modal-footer>
      <div class="w-100">
        <template v-if="!showLoading">
          <b-button
            v-if="
              USER().rol == ROLES.SUPER ||
                USER().rol === ROLES.ADMIN ||
                USER().rol === ROLES.CALIFICACION
            "
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="float-right"
            @click="saveInstitucion"
          >
            Guardar
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-primary"
            class="float-right mr-1"
            @click="onlyClose"
          >
            Cerrar
          </b-button>
        </template>
        <div v-if="showLoading" class="text-center mt-1">
          <b-spinner variant="primary" label="Text Centered" />
        </div>
        <b-alert
          :show="dismissCountDown"
          v-height-fade.appear
          :variant="variante"
          style="position:absolute; bottom:55px;  width:92%; margin-left:-4px"
          @dismiss-count-down="countDownChanged"
        >
          <div
            :class="{
              'alert-body danger': variante == 'danger',
              'alert-body success': variante == 'success',
            }"
          >
            {{ messageError }}
          </div>
        </b-alert>
      </div>
    </template>
  </b-modal>
</template>
<script>
import {
  BModal,
  BRow,
  BCol,
  BFormInput,
  BAlert,
  BButton,
  BSpinner,
  VBPopover,
  BPopover,
  //  xxx
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { heightFade } from '@core/directives/animations'
import store from '@/store'
import { ref } from '@vue/composition-api'
import apiCall from '../../utils/apiCall'
import {
  URL,
  USER,
  ROLES,
  // xx
} from '../../utils/variables'

export default {
  components: {
    BModal,
    BRow,
    BCol,
    BFormInput,
    BAlert,
    BButton,
    BSpinner,
    BPopover,
  },
  directives: {
    Ripple,
    heightFade,
    'b-popover': VBPopover,
  },
  props: {
    institucion: Object,
    institucionAuxiliar: Object,
    listAuditoria: Array,
    idUser: String,
  },
  setup(props, { emit }) {
    const showLoading = ref(false)
    const hasError = ref(false)
    const dismissCountDown = ref(0)
    const variante = ref('danger')
    const croppaFoto = ref({})
    const messageError = ref('')
    const dismissSecs = ref(3)
    const popoverShow = ref(false)

    const { postApi } = apiCall()
    function countDownChanged(dismissCountDownAux) {
      dismissCountDown.value = dismissCountDownAux
    }
    function showMessageAlert(type, mensaje) {
      variante.value = type
      messageError.value = mensaje
      dismissCountDown.value = dismissSecs.value
    }
    function getPicturePlayer(croppa) {
      let fotografia = ''
      if (croppa.value.chosenFile == null) {
        fotografia = ''
      } else {
        const fotografiaBase64 = croppa.value.generateDataUrl(
          'image/png',
          // eslint-disable-next-line
          0.8
        )
        fotografia = fotografiaBase64
      }
      return fotografia
    }
    function setCroppaRefresh() {
      setTimeout(() => {
        croppaFoto.value.refresh()
      }, 100)
    }
    function initModal() {
      props.institucion.nombre = ''
      props.institucion.apodo = ''
      props.institucion.facebook = ''
      props.institucion.email = ''
      props.institucion.telefono = ''
      props.institucion.presidente = ''
      props.institucion.vicepresidente = ''
      // props.fotografia = ''
      setCroppaRefresh()
    }
    function focusInput(id, error) {
      document.getElementById(id).focus()
      messageError.value = error
    }
    function hasErrorForm() {
      let error = false
      if (
        props.institucion.nombre === '' ||
        props.institucion.nombre === null ||
        props.institucion.nombre === undefined
      ) {
        focusInput('floating-institucion', 'Nombre institución es requerido')
        error = true
      } else if (
        props.institucion.apodo === '' ||
        props.institucion.apodo === null ||
        props.institucion.apodo === undefined
      ) {
        focusInput('floating-apodo', 'Apodo institución es requerido')
        error = true
      }
      return error
    }
    function getStringChanges() {
      // let has = false
      props.institucion.fotografia = getPicturePlayer(croppaFoto)

      let stringFinal = ''
      if (props.institucionAuxiliar.nombre !== props.institucion.nombre) {
        stringFinal += `cambia nombre Institución de ${props.institucionAuxiliar.nombre} a ${props.institucion.nombre} `
      }
      if (props.institucionAuxiliar.apodo !== props.institucion.nombre) {
        stringFinal += `cambia apodo Institución de ${props.institucionAuxiliar.apodo} a ${props.institucion.apodo} `
      }
      if (
        props.institucion.fotografia !== '' &&
        props.institucion.fotografia !== undefined
      ) {
        stringFinal += 'cambia logo Institucion '
      }

      return stringFinal
    }
    async function saveInstitucion() {
      // console.log(institucionAuxiliar.value)
      let dataMovimientoString = ''
      if (props.institucion.id_institucion !== null) {
        dataMovimientoString = getStringChanges()
      }
      hasError.value = hasErrorForm()
      if (!hasError.value) {
        showLoading.value = true
        props.institucion.fotografia = getPicturePlayer(croppaFoto)
        const path = 'ApiConfiguration/insertInstitucion'
        const data = {
          institucion: props.institucion,
          idUser: props.idUser,
          idTorneo:
            store.getters['someVariables/getTorneoSeleccionado'].id_torneo,
          tieneCambios: dataMovimientoString === '' ? 'no' : 'si',
          dataMovimiento: `${dataMovimientoString}`,
        }
        // console.log(data)

        const response = await postApi(URL, path, data)
        // console.log(response)
        if (response != null) {
          if (response.flag === 'si') {
            if (response.accion === 'insert') {
              showMessageAlert('success', 'INSTITUCION creada exitosamente')
              // props.institucion.id_institucion = response.info.id_institucion
              // props.institucion.foto = response.info.foto
              initModal()
              emit('recargar', response.info)
            } else {
              // showMessageAlert('success', 'INSTITUCION actualizada exitosamente')
              emit('recargarUpdate', response.info)
            }
          } else {
            showMessageAlert('danger', response.mensaje)
          }
        } else {
          showMessageAlert('danger', 'Institución ya existe')
        }
        showLoading.value = false
      } else {
        variante.value = 'danger'
        dismissCountDown.value = dismissSecs.value
      }
    }

    function resetModal(bvModalEvt) {
      bvModalEvt.preventDefault()
      // initModal()
      // emit('recargar')
      countDownChanged(0)
      store.commit('someVariables/UPDATE_SHOW_NEW_INSTITUCION', false)
    }
    function onlyClose() {
      store.commit('someVariables/UPDATE_SHOW_NEW_INSTITUCION', false)
    }
    return {
      showLoading,
      dismissCountDown,
      variante,
      countDownChanged,
      croppaFoto,
      messageError,
      saveInstitucion,
      resetModal,
      onlyClose,
      hasError,
      USER,
      ROLES,
      popoverShow,
    }
  },
}
</script>
<style>
.danger {
  background-color: #ea5454c7;
  border-radius: 5px;
  color: white;
}
.success {
  background-color: #2be025c7;
  border-radius: 5px;
  color: white;
}
</style>
